import apiClient from './api';

export interface NoticeUpdateRequest {
  title: string;
  content: string;
  type: string;
}

export const adminNoticeService = {
  /** 공지사항 수정 */
  updateNotice: async (noticeId: number, data: NoticeUpdateRequest): Promise<void> => {
    await apiClient.put(`/admin/notices/${noticeId}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },

  /** 공지사항 삭제 */
  deleteNotice: async (noticeId: number): Promise<void> => {
    await apiClient.delete(`/admin/notices/${noticeId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
  },
};
